<div class="w-full h-full">
    <app-tab-header [tabs]="tabs">
        <span 
            matTooltip="Export to Excel" 
            matTooltipPosition="left" 
            matTooltipClass="custom-orange-tooltip">
            <app-print-button (togglePrint)="print()"></app-print-button>
        </span>
    </app-tab-header>
    
    <div class="w-900-px mx-auto">
        <form [formGroup]="form">
            <!-- Row 1: Names -->
            <div class="grid grid-cols-12 gap-3">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-100-px font-semibold">First Name:</span>
                        <input 
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            style="text-transform: capitalize;" 
                            formControlName="firstName"  
                            type="text" 
                            placeholder="First Name">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-120-px font-semibold">Middle Name:</span>
                        <input 
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            style="text-transform: capitalize;" 
                            formControlName="middleName"  
                            type="text" 
                            placeholder="Middle Name">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-100-px font-semibold">Last Name:</span>
                        <input 
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            style="text-transform: capitalize;" 
                            formControlName="lastName"  
                            type="text" 
                            placeholder="Last Name">
                    </div>
                </div>
            </div>
            
            <!-- Row 2: Phone Number and Dates -->
            <div class="grid grid-cols-12 gap-3 mt-3">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-130-px font-semibold">Phone Number:</span>
                        <input 
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="phoneNumber"  
                            type="text" 
                            placeholder="Phone Number">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <app-date-input 
                            class="w-full"
                            label="Date From:"
                            [parentForm]="form"
                            controlName="dateFrom">
                        </app-date-input> 
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <app-date-input 
                            class="w-full text-black"
                            label="Date To:"
                            [parentForm]="form"
                            controlName="dateTo">
                        </app-date-input> 
                    </div>
                </div>
            </div>
            
            <!-- Row 3: Transaction ID, Product Code, Category -->
            <div class="grid grid-cols-12 gap-3 mt-3">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-140-px font-semibold">Transaction ID:</span>
                        <input 
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="transactionId" 
                            type="text" 
                            placeholder="Transaction ID">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-130-px font-semibold">Product Code:</span>
                        <input 
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="productCode" 
                            type="text" 
                            placeholder="Product Code">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-80-px font-semibold">Category:</span>
                        <app-dropdown-field
                        [options]="categoryOptions"
                        [selectedText]="categoryType_text"
                        placeholder="== Select an option =="
                        (selectionChange)="setCategory($event.label, $event.value)">
                        </app-dropdown-field>
                    </div>
                </div>
            </div>
        </form>
        
        <!-- Submit Button -->
        <div class="w-full flex items-center justify-center mt-10 mb-4">
            <button 
                (click)="submit()" 
                class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2">
                submit
            </button>
        </div>  
    </div>

    <!-- Data Table Section -->
    <div *ngIf="showTable">
        <div *ngIf="submitted">
            <app-table-controls
                [currentLimit]="size"
                [searchPlaceholder]="'Search'"
                (limitChangeEvent)="onLimitChangeFromComponent($event)"
                (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
                (keydownEvent)="keyDownFunction($event)">
            </app-table-controls>
            
            <app-data-table
                [tableSubHeader]="tableSubHeader"
                [isLoading]="isLoading"
                [sort_type]="sort_type"
                (toggleOnSort)="sortList($event.key, $event.type)">
                <tr class="focus:outline-none" *ngFor="let redeem of redeem_lists">
                    <td>{{ redeem.transactionId | nullWithDefault }}</td>
                    <td>{{ redeem.firstName | nullWithDefault }}</td>
                    <td>{{ redeem.middleName | nullWithDefault }} </td>
                    <td>{{ redeem.lastName | nullWithDefault }}</td>
                    <td>{{ redeem.phoneNumber | nullWithDefault }}</td>
                    <td>{{ redeem.productName | nullWithDefault }}</td>
                    <td>{{ redeem.productCode | nullWithDefault }}</td>
                    <td>{{ redeem.recipient | nullWithDefault }}</td>
                    <td>{{ redeem.rewardPointsUsed | nullWithDefault }}</td>
                    <td>{{ redeem.dateTime | date:'yyyy-MM-dd HH:mm:ss' | nullWithDefault }}</td>
                    <td>{{ redeem.status | nullWithDefault }}</td>
                </tr>
            </app-data-table>

            <!-- Empty state (only shown after loading completes) -->
            <div *ngIf="!isLoading && (!redeem_lists || redeem_lists.length === 0)"
                class="bg-light-orange w-full py-3 text-gray-500"
                style="text-align: center; border-bottom: 1px solid rgba(0,0,0,0.2);">
                <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;">
                    <img src="../../../../assets/images/icon/no-data.webp"
                        alt="No Data"
                        style="height: 48px; opacity: 0.4;"
                        onerror="this.style.display='none'">
                    <span class="font-semibold text-xs uppercase tracking-wide">No records found</span>
                    <span class="italic text-xs">Try adjusting your search or filter criteria.</span>
                </div>
            </div>
            
            <app-pagination
                [currentPage]="current_page"
                [totalPages]="total_pages"
                [pageSize]="size"
                [totalItems]="total"
                (pageChange)="setPage($event)"
                (previousPage)="prevPage()"
                (nextPage)="nextPage()"
                showTotalEntries="true">
            </app-pagination>
        </div>
    </div>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>